var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.293.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L12.586 9H1a1 1 0 0 1 0-2h11.586L7.293 1.707a1 1 0 0 1 0-1.414Z",
    fill: "currentColor"
  })));
};

export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMjkyODkgMC4yOTI4OTNDNy42ODM0MiAtMC4wOTc2MzExIDguMzE2NTggLTAuMDk3NjMxMSA4LjcwNzExIDAuMjkyODkzTDE1LjcwNzEgNy4yOTI4OUMxNi4wOTc2IDcuNjgzNDIgMTYuMDk3NiA4LjMxNjU4IDE1LjcwNzEgOC43MDcxMUw4LjcwNzExIDE1LjcwNzFDOC4zMTY1OCAxNi4wOTc2IDcuNjgzNDIgMTYuMDk3NiA3LjI5Mjg5IDE1LjcwNzFDNi45MDIzNyAxNS4zMTY2IDYuOTAyMzcgMTQuNjgzNCA3LjI5Mjg5IDE0LjI5MjlMMTIuNTg1OCA5SDFDMC40NDc3MTUgOSAwIDguNTUyMjggMCA4QzAgNy40NDc3MiAwLjQ0NzcxNSA3IDEgN0gxMi41ODU4TDcuMjkyODkgMS43MDcxMUM2LjkwMjM3IDEuMzE2NTggNi45MDIzNyAwLjY4MzQxNyA3LjI5Mjg5IDAuMjkyODkzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";